<template>
  <div>
    <!-- 个人信息 -->
    <div id="personal-info">
      <div class="white-card">
        <div class="photo">
          <img src="@/assets/images/me/photo.jpg" alt="" />
        </div>
        <h2 style="font-weight: normal">sunn</h2>
        <p style="margin-top: 8px; text-indent: 0; color: #666">
          一个喜欢折腾与开发有关的程序员
        </p>
        <div class="contact">
          <div class="contact-type" @click.stop="handleIcon('wechat')">
            <i class="iconfont icon-weixin-copy icon"></i>
            <!-- <img src="./assets/images/me/wechat.jpg" alt="" /> -->
          </div>
          <div class="contact-type" @click.stop="handleIcon('qq')">
            <i class="iconfont icon-qq icon" style="color: #7bb0e5"></i>
            <!-- <img src="./assets/images/me/wechat.jpg" alt="" /> -->
          </div>
          <div class="contact-type" @click.stop="handleIcon('csdn')">
            <i class="iconfont icon-csdn icon" style="color: #dd1700"></i>
            <!-- <img src="./assets/images/me/wechat.jpg" alt="" /> -->
          </div>
        </div>
      </div>
    </div>

    <!-- 文章信息 -->
    <div id="article-info" v-if="articleData && articleData.length">
      <div class="white-card">
        <section class="title">
          <h3><i class="iconfont icon-yuedu1"></i>文章数据</h3>
          <a href="/#/blogs">更多<i class="iconfont icon-youjiantou"></i></a>
        </section>
        <ul>
          <li v-for="(item, index) in articleData" :key="index">
            <span v-if="item.count">{{ item.name }}</span>
            <span>({{ item.count || 0 }})</span>
          </li>
        </ul>
      </div>
    </div>

    <!-- 粉丝投稿 -->
    <div id="article-info" v-if="contributeData && contributeData.length">
      <div class="white-card">
        <section class="title">
          <h3 style="color: #fd9393">
            <i
              class="iconfont icon-remen"
              style="text-shadow: 0px 0px 2px #fd9393"
            ></i
            >群英荟萃
          </h3>
          <a href="/#/assemble">更多<i class="iconfont icon-youjiantou"></i></a>
        </section>
        <ul>
          <li v-for="(item, index) in contributeData" :key="index">
            <span v-if="item.count">{{ item.name }}</span>
            <span>({{ item.count || 0 }})</span>
          </li>
        </ul>
      </div>
    </div>

    <!-- 网站信息 -->
    <div id="article-info">
      <div class="white-card">
        <section class="title">
          <h3 style="color: #edc87e">
            <i
              class="iconfont icon-shuju"
              style="text-shadow: 0px 0px 2px #edc87e"
            ></i
            >网站统计
          </h3>
        </section>
        <ul>
          <li>
            <span>已运行:</span>
            <span>{{ (siteStats.网站运行天数 || 0) + "天" }}</span>
          </li>
          <li>
            <span>文章:</span> <span>{{ siteStats.文章总数 || 0 }}</span>
          </li>
          <li>
            <span>分类:</span> <span>{{ siteStats.分类总数 || 0 }}</span>
          </li>
          <li>
            <span>评论:</span> <span>{{ siteStats.评论总数 || 0 }}</span>
          </li>
          <li>
            <span>访问量:</span> <span>{{ siteStats.访问总数 || 0 }}</span>
          </li>
        </ul>
      </div>
    </div>

    <popup
      style="display: none"
      @hide="hide"
      id="popup-box"
      :visible="dialogShow"
      :maxW="'300px'"
    >
      <div
        style="height: 300px; width: 300px; text-align: center; margin: 0 auto"
      >
        <img :src="imgUrl" alt="" style="height: 100%; width: 100%" />
      </div>
    </popup>
  </div>
</template>
<script>
import data from "./index.js";
export default data;
</script>
<style scoped>
#personal-info,
#article-info {
  padding: 1px 0;
}
#article-info ul li {
  letter-spacing: 1px;
}
.white-card {
  text-align: center;
}
.contact .icon {
  font-size: 40px;
}

.iconfont {
  font-size: 20px;
  text-align: center;
}
.iconfont span {
  font-size: 14px;
  color: #aaa;
}
.title {
  display: flex;
  align-items: center;
  position: relative;
}
.title a {
  text-decoration: none;
  position: absolute;
  right: 0;
  color: #aaa;
  font-size: 14px;
}
.title a i {
  font-size: 14px;
}
.title h3 {
  color: #7eb2d9;
  margin: 0 auto;
  letter-spacing: 1px;
}
.title h3 i {
  padding-right: 5px;
  text-shadow: 0px 0px 2px #7eb2d9;
}
</style>
